import React from "react";
import { Box } from "@material-ui/core";
import AppButtonComponent from "../../../components/form/app-button";

const ButtonsComponent = () => {
  return (
    <Box
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "1rem",
        padding: "0 40px",
        flexWrap: "wrap",
      }}
    >
      <Box
        className="buttons-size"
        style={{ display: "flex", alignItems: "center", gap: "1.5rem" }}
      >
        <AppButtonComponent size="small">Button Small</AppButtonComponent>
        <AppButtonComponent size="medium">Button Medium</AppButtonComponent>
        <AppButtonComponent size="large">Button Large</AppButtonComponent>
      </Box>

      <Box
        className="buttons-contained"
        style={{ display: "flex", alignItems: "center", gap: "1.5rem" }}
      >
        <AppButtonComponent size="medium" variant="contained" color="primary">
          Button Contained Primary
        </AppButtonComponent>
        <AppButtonComponent
          size="medium"
          variant="contained"
          color="primary"
          disabled
        >
          Button Contained Primary Disabled
        </AppButtonComponent>
        <AppButtonComponent size="medium" variant="contained" color="secondary">
          Button Contained Secondary
        </AppButtonComponent>
        <AppButtonComponent
          size="medium"
          variant="contained"
          color="secondary"
          disabled
        >
          Button Contained Secondary Disabled
        </AppButtonComponent>
      </Box>

      <Box
        className="buttons-outlined"
        style={{ display: "flex", alignItems: "center", gap: "1.5rem" }}
      >
        <AppButtonComponent size="medium" variant="outlined" color="primary">
          Button Outlined Primary
        </AppButtonComponent>
        <AppButtonComponent
          size="medium"
          variant="outlined"
          color="primary"
          disabled
        >
          Button Outlined Primary Disabled
        </AppButtonComponent>
        <AppButtonComponent size="medium" variant="outlined" color="secondary">
          Button Outlined Secondary
        </AppButtonComponent>
        <AppButtonComponent
          size="medium"
          variant="outlined"
          color="secondary"
          disabled
        >
          Button Outlined Secondary Disabled
        </AppButtonComponent>
      </Box>
      <Box
        className="buttons-text"
        style={{ display: "flex", alignItems: "center", gap: "1.5rem" }}
      >
        <AppButtonComponent size="medium" variant="text" color="primary">
          Button Text Primary
        </AppButtonComponent>
        <AppButtonComponent
          size="medium"
          variant="text"
          color="primary"
          disabled
        >
          Button Text Primary Disabled
        </AppButtonComponent>
        <AppButtonComponent size="medium" variant="text" color="secondary">
          Button Text Secondary
        </AppButtonComponent>
        <AppButtonComponent
          size="medium"
          variant="text"
          color="secondary"
          disabled
        >
          Button Text Secondary Disabled
        </AppButtonComponent>
      </Box>
    </Box>
  );
};

export default ButtonsComponent;
